module.exports = __webpack_public_path__ + "assets/34b46ce9f810f81a70b1e5e8120f3b49.mp3";